import { Box, Flex, Text } from '@fullstory/components';
import { BulkActionResourceType } from '@fullstory/library-ui';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface SuggestionsEmptyStateProps {
  generateSuggestionsBtn: ReactNode;
  filters?: ReactNode | ((resetSelected: () => void) => ReactNode);
  objectType: BulkActionResourceType;
}

export const SuggestionsEmptyState = ({
  generateSuggestionsBtn,
  filters,
  objectType,
}: SuggestionsEmptyStateProps) => (
  <>
    {filters && (
      <Box padding={[0, 24]}>
        <Flex column alignItems="flex-start" gap={16}>
          {typeof filters === 'function' ? filters(() => {}) : filters}
        </Flex>
      </Box>
    )}
    <Box data-component="SuggestionsEmptyState" padding={64}>
      <Flex
        data-component="SuggestionsEmptyState"
        column
        alignItems="center"
        justifyContent="center"
        gap={16}
      >
        <img src="/s/img/sentiment-blobs/blob-zen.png" alt="sentiment blob" width="160px" />
        <Text appearance="heading1" align="center" color="emphasized">
          <FormattedMessage
            defaultMessage="You don't have any suggested {objectType}s right now."
            values={{ objectType: objectType.toLowerCase() }}
            id="tsJg9B"
          />
        </Text>

        <Box marginBottom={16}>
          <Text appearance="bodyMedium" align="center" color="secondary">
            <FormattedMessage
              defaultMessage="Click the button below to get some fresh ideas!"
              id="vaD5T6"
            />
          </Text>
        </Box>

        {generateSuggestionsBtn}
      </Flex>
    </Box>
  </>
);
